module.exports = __webpack_public_path__ + "img/ic_split.d55ae7c8.svg";